export default class ServiceType {
  public id!: number
  public name!: string
  public price!: number
  public duration!: number
}
